import { Editor, Element, Node } from 'slate';
import { isElementType } from '.';
import { BlockType } from '../types';

// Slate editor types for (un-)ordered lists
const listTypes: Element['type'][] = ['bulleted-list', 'numbered-list'];

// Is element type is of list type
export const isListType = (type: Element['type']): boolean =>
	listTypes.includes(type);

// Is node a list
export const isList = (node: Node): boolean =>
	listTypes.some((type) => isElementType(node, type));

// Is node (within editor) the given block type
export const isBlockActive = (
	editor: Editor,
	blockType: BlockType
): boolean => {
	const blockEntries = Array.from(
		Editor.nodes(editor, {
			match: (node) => isElementType(node, blockType),
		})
	);

	return !!blockEntries.length;
};
